import React, { useEffect, useState } from "react";
import './Termsofservice.css';
import { Link } from "react-router-dom";
import Logo from "../../assets/images/inmate-logo.png";
import InmateInboxImg from '../../assets/images/logo-portrait@2x.png'
import useTranslate from "../../config/useTranslate";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import TranslateFile from "../../config/TranslateFile";
import { getStoredValue } from "../../_helpers/storagehelper";


function PrivacyPolicy() {
    const [translatedSections, setTranslatedSections] = useState(sections);
    const [overviewcontent, setTranslatedOverviewContent] = useState('This Privacy Policy governs the manner in which Inmate Inbox LLC collects, uses, maintains and discloses information collected from users (each, a "User") of the http://www.inmateinbox.com website ("Site"). This privacy policy applies to the Site and all products and services offered by Inmate Inbox LLC.');
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const { translateMessages } = useTranslate();
    const currentLang = TranslateFile()


    useEffect(() => {
        const fetchTranslations = async () => {
            const Lang = getStoredValue("lang") || "en";

            if (Lang === "en") {
                setTranslatedSections(sections);
                setTranslatedOverviewContent(overviewcontent);
                hideLoader();
                return;
            }

            showLoader();

            try {
                const [overviewContentText] = await translateMessages([overviewcontent], Lang);

                setTranslatedOverviewContent(overviewContentText || overviewcontent);

                const combinedTexts = sections.flatMap((s) => [s.title, s.content]);
                const translatedTexts = await translateMessages(combinedTexts, Lang);

                const translated = sections.map((section, i) => ({
                    ...section,
                    translatedTitle: translatedTexts[i * 2],
                    translatedContent: translatedTexts[i * 2 + 1]
                }));

                setTranslatedSections(translated);
            } catch (error) {
                setTranslatedSections(sections);
                setTranslatedOverviewContent(overviewcontent);
                hideLoader();
                console.error("Translation error:", error);
            }

            hideLoader();
        };

        fetchTranslations();
    }, []);

    return (
        <div className="fixed-window-privacy">
            <div className="d-flex justify-content-center mb-4 align-items-center">
                {/* <img src={Logo} alt="Logo" /> */}
                <img className="ms-2" src={InmateInboxImg} style={{ width: '140px' }}></img>
            </div>

            <div className="privacy-content">

                <h3 className="mb-4 fw-700 fs-26px">{currentLang?.PRIVACY_POLICY}</h3>
                <div className="card border-radius-all shadow-sm">
                    <div className="card-body">
                        <p className="mt-2 mb-4">
                            {overviewcontent}                </p>
                        {/* Accordion Structure */}
                        <div className="accordion" id="accordion">
                            {translatedSections.map((section, index) => (
                                <div className="accordion-item border-0" key={index}>
                                    <div className="accordion-header" id={`heading${index}`}>
                                        <button
                                            className="accordion-button px-3 py-2"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${index}`}
                                            aria-expanded="true"
                                            aria-controls={`collapse${index}`}>
                                            {section?.translatedTitle || section.title}
                                        </button>
                                    </div>
                                    <div
                                        id={`collapse${index}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby={`heading${index}`}
                                        data-bs-parent="#accordion">
                                        <div className="accordion-body" dangerouslySetInnerHTML={{ __html: section?.translatedContent || section.content }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button
                            type="button"
                            className="btn btn-danger mtt-4"
                            onClick={() => {
                                window.close();
                            }}>
                            {currentLang?.buttons?.Close}
                        </button>
                    </div>
                </div>
            </div>
            {loader}
        </div>
    );
}
const sections = [
    {
        title: "Personal identification information",
        content: `We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, register on the site, place an order, fill out a form, and in connection with other activities, services, features or resources we make available on our Site. Users may be asked for, as appropriate, name, e-mail address, phone number. Users may, however, visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.`
    },
    {
        title: "Non-personal identification information",
        content: `We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information`
    },
    {
        title: "Web browser cookies",
        content: `Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.`
    },
    {
        title: "How we use collected information",
        content: `<b>To run and operate our Site</b><br /><br />
                  We may need your information to display content on the Site correctly.<br /><br />
                  <b>To improve customer service</b><br /><br />
                  Information you provide helps us respond to your customer service requests and support needs more efficiently.<br /><br />
                  <b>To personalize user experience</b><br /><br />
                  We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.<br /><br />
                  <b>To improve our Site</b><br /><br />
                  We may use feedback you provide to improve our products and services.<br /><br />
                  <b>To process payments</b><br /><br />
                  We may use the information Users provide about themselves when placing an order only to provide service to that order. We do not share this information with outside parties except to the extent necessary to provide the service.<br /><br />
                  <b>To run a promotion, contest, survey, or other Site feature</b><br /><br />
                  To send Users information they agreed to receive about topics we think will be of interest to them.<br /><br />
                  <b>To send periodic e-mails</b><br /><br />
                  We may use the e-mail address to send User information and updates pertaining to their order. It may also be used to respond to their inquiries, questions, and/or other requests.`
    },
    {
        title: "Jail or Prison Facilities - Monitoring",
        content: `All communications with inmates is subject to monitoring by jail personal, and other law enforcement personnel. Other personal information we collect about you may be shared with law enforcement (excluding your full credit card number and CSC). There is no expectation of privacy regarding any messages or photos sent to and from an inmate using this service.`
    },
    {
        title: "How we protect your information",
        content: `We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.`
    },
    {
        title: "Sharing your personal information",
        content: `We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.`
    },
    {
        title: "Electronic newsletters",
        content: `If User decides to opt-in to our mailing list, they will receive e-mails that may include company news, updates, related product or service information, etc. We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.`
    },
    {
        title: "Compliance with children's online privacy protection act",
        content: `Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our Site from those we actually know are under 13, and no part of our website is structured to attract anyone under 13.`
    },
    {
        title: "Changes to this privacy policy",
        content: `Inmate Inbox LLC has the discretion to update this privacy policy at any time. When we do, we will post a notification on the main page of our Site. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.`
    },
    {
        title: "Your acceptance of these terms",
        content: `By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.`
    },
    {
        title: "Contacting Us",
        content: `If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at <a href="mailto:support@inmateinbox.com">support@inmateinbox.com</a>. This document was last updated on January 30, 2017`
    },

];

export default PrivacyPolicy;